declare const THREE: any;

export class Box {

  protected box = new THREE.Box3();
  private _size = new THREE.Vector3();
  private _center = new THREE.Vector3();

  constructor(object?) {
    if (object) {
      this.update(object);
    }
  }

  update(object) {
    this.box.setFromObject(object);
    this.box.getCenter(this._center);
    this.box.getSize(this._size);
  }

  get center() {
    return this._center;
  }

  get length(): number {
    return this._size.x;
  }

  get height(): number {
    return this._size.z;
  }

  get min() {
    return this.box.min;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/lightMap/Box.ts